import { render, staticRenderFns } from "./HowToEarnPointsModal.vue?vue&type=template&id=61f83b2b&scoped=true&"
import script from "./HowToEarnPointsModal.vue?vue&type=script&lang=js&"
export * from "./HowToEarnPointsModal.vue?vue&type=script&lang=js&"
import style0 from "./HowToEarnPointsModal.vue?vue&type=style&index=0&id=61f83b2b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f83b2b",
  null
  
)

export default component.exports